export const GTM_ID = 'GTM-5RDPB7Z6';
export const GA_ID = 'G-BWJ5N1YSNJ';
